import { mapGetters, mapActions, mapMutations } from 'vuex'
import * as UserType from '@/helper/UserType'
import {
  AddProvider,
  EditProvider,
  EnableProvider,
  EditCostVariable,
  EditCostProvider
} from '@/components'

export default {
  name: 'SystemProviders',
  components: {
    AddProvider,
    EditProvider,
    EnableProvider,
    EditCostVariable,
    EditCostProvider
  },
  data () {
    return {
      UserType,
      isLoading: false,
      managerEditCostVariable: false,
      managerEditCostProvider: false,
      managerConfirmDeleteInvoice: false,
      search: '',
      searchName: '',
      searchSupplier: null,
      searchType: null,
      searchCategory: null,
      suppliers: [{ text: 'Todos', value: null }],
      types: [{ text: 'Todas', value: null }],
      categories: [{ text: 'Todas', value: null }],
      selectedProvider: '',
      selectedFilter: 'name',
      headers: [
        {
          text: 'Ações', value: 'actions', align: 'center', sortable: false
        },
        { text: 'Bloqueado', value: 'enabled', align: 'center' },
        { text: 'Nome', value: 'name', align: 'left' },
        { text: 'Nome da fonte', value: 'sourceName', align: 'left' },
        { text: 'Tipo', value: 'type', align: 'left' },
        { text: 'Categoria', value: 'systemProviderClassification', align: 'left' },
        { text: 'Valor de custo', value: 'minimumPrice', align: 'right' }
      ],
      listActions: [
        {
          name: 'Editar',
          value: 'edit',
          action: (item) => this.managerEditCostProviderAction(item),
          disabled: () => this.validateDisabledButton('edit')
        }
      ]
    }
  },

  computed: {
    ...mapGetters(['getterAccount', 'getterSystemProviders']),
    filteredSystemProviders () {
      let result = ''
      if (this.search !== '') {
        result = this.getterSystemProviders.filter((item) => {
          if (item[this.selectedFilter] !== null) {
            return item[this.selectedFilter].toLowerCase().includes(this.search.toLowerCase())
          }

          return item[this.selectedFilter]
        })
      } else {
        result = this.getterSystemProviders
      }

      if (this.searchSupplier !== null) {
        result = this.getterSystemProviders.filter((item) => item.idSource === this.searchSupplier)
      }

      if (this.searchType !== null) {
        result = this.getterSystemProviders.filter((item) => item.type === this.searchType)
      }

      if (this.searchCategory !== null) {
        result = this.getterSystemProviders.filter((item) => item.idSystemProviderClassification === this.searchCategory)
      }
      return result
    },
    filteredHeader () {
      return this.headers.filter(
        (item) => item.value === 'name' || item.value === 'type'
      )
    }
  },
  mounted () {
    this.getAllSystemProviders()
    this.getSources()
    this.getSystemProviderClassification()
    this.getterSystemProviders.forEach((item) => {
      if (!this.types.includes(item.type)) {
        this.types.push(item.type)
      }
    })
  },
  methods: {
    ...mapActions(['actionGetAllSystemProviders', 'actionGetSources', 'actionGetSystemProviderClassifications']),
    ...mapMutations(['SET_SELECTED_SYSTEM_PROVIDER']),
    returnTrueValueName (item) {
      return item.enabled ? 'Bloquear' : 'Desbloquear'
    },
    redirect () {
      this.$router.push({ name: 'ReportCostsChanges' })
    },
    getSources () {
      this.actionGetSources().then((response) => {
        this.suppliers.push(...response.data.map((item) => ({
          text: item.sourceName,
          value: item.idSource
        })))
      }).catch((error) => {
        console.log(error)
        this.isLoading = false
      })
    },
    getSystemProviderClassification () {
      this.actionGetSystemProviderClassifications().then((response) => {
        this.categories.push(...response.data.map((item) => ({
          text: item.name,
          value: item.idSystemProviderClassification
        })))
      }).catch((error) => {
        console.log(error)
      })
    },
    returnSystemProviderClassification (id) {
      if (this.categories && id !== null) {
        const result = this.categories.find(item => item.value === id)
        if (result && result.hasOwnProperty('text')) {
          return result.text
        }
      }

      if (id === null) {
        return '-'
      }

      return null
    },
    searchByName (e) {
      this.search = e.target.value
    },
    filterByType () {
      this.search = this.searchType
      this.selectedFilter = 'type'
    },
    filterByCategory () {
      this.search = this.searchCategory
      this.selectedFilter = 'idSystemProviderClassification'
    },
    filterBySupplier () {
      this.search = this.searchSupplier
      this.selectedFilter = 'idSource'
    },
    validateDisabledButton (type) {
      return (
        type === 'enable'
        && this.getterAccount.idUserType !== UserType.USER_IMPLANTADOR
      )
    },
    editVariable (type) {
      this.managerEditCostVariable = !this.managerEditCostVariable
      this.variable = type
    },
    async getAllSystemProviders () {
      this.isLoading = true
      try {
        await this.actionGetAllSystemProviders()
      } catch (error) {
        this.isLoading = false
      } finally {
        this.isLoading = false
      }
    },
    managerEditCostProviderAction (provider) {
      this.selectedProvider = provider
      this.SET_SELECTED_SYSTEM_PROVIDER(provider)
      this.managerEditCostProvider = !this.managerEditCostProvider
    }
  }
}
